<template>
  <van-row class="page-wrapper" justify="center">
    <van-col class="itserve-center mb-25" span="24">
      <template v-if="isLoading">
        <!-- Скелетон для отображения во время загрузки -->
        <div class="white-wrapper place-content-center mt-15 top-radius">
          <div class="apply-loader">
            <Image
              col="0"
              src="~/img/logo-zhitomir.png"
              width="300"
              marginTop="20"
              stretch="aspectFill"
              class="company-logo m-t-10"
            />
          </div>
        </div>
        <div class="account-skeleton place-content-center">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
      </template>
      <template v-else-if="account">
        <button
          type="button"
          class="donora-ticker"
          aria-label="Donora"
          @click="openDonoraTicker"
        >
          <span class="donora-ticker-heart" aria-hidden="true">
            <svg viewBox="0 0 64 64">
              <defs>
                <radialGradient
                  id="donoraTickerHeartGlow"
                  cx="34%"
                  cy="26%"
                  r="70%"
                >
                  <stop offset="0%" stop-color="#ffb3c1" />
                  <stop offset="42%" stop-color="#ff4f73" />
                  <stop offset="100%" stop-color="#f0184e" />
                </radialGradient>
                <linearGradient
                  id="donoraTickerHeartShine"
                  x1="18"
                  y1="13"
                  x2="42"
                  y2="44"
                >
                  <stop offset="0%" stop-color="#ffffff" stop-opacity="0.72" />
                  <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
                </linearGradient>
              </defs>
              <path
                class="ticker-heart-fill"
                d="M32 54.2S9 40.4 9 24.2C9 15.8 15.1 10 22.7 10c4.3 0 7.6 2 9.3 5.4C33.7 12 37 10 41.3 10 48.9 10 55 15.8 55 24.2c0 16.2-23 30-23 30Z"
              />
              <path
                class="ticker-heart-shine"
                d="M19.6 17.7c4.2-3.5 9.6-1.6 12.4 4.1 2.8-5.7 8.2-7.6 12.4-4.1"
              />
            </svg>
          </span>
          <span class="donora-ticker-viewport">
            <span class="donora-ticker-track">
              <span>{{ $t("donora.tickerText") }}</span>
              <span>{{ $t("donora.tickerText") }}</span>
            </span>
          </span>
        </button>
        <div class="white-wrapper place-content-center mt-15 top-radius">
          <div class="apply-loader">
            <Image
              col="0"
              src="~/img/logozhoek.png"
              width="300"
              marginTop="20"
              stretch="aspectFill"
              class="company-logo m-t-10"
            />
          </div>
        </div>
        <account
          :account="account"
          :show-balance="true"
          class="home-account-shadow place-content-center"
        />
      </template>
      <div class="main-page-account account-menu-modern">
        <router-link
          :to="{ name: 'Pay', params: $route.params }"
          class="account-pay-button"
        >
          Оплатити
        </router-link>

        <div class="account-feature-grid">
          <router-link
            :to="{ name: 'Donora', params: $route.params }"
            class="account-feature-card account-feature-donora"
          >
            <span class="account-feature-icon account-feature-logo">
              <img :src="edopomogaLogo" alt="" />
            </span>
            <span class="account-feature-label">
              <span class="account-feature-title">Допомога</span>
              <span class="account-feature-arrow">›</span>
            </span>
          </router-link>

          <router-link
            v-if="account"
            :to="{
              name: 'SendIndications',
              params: { account: $route.params.account },
            }"
            class="account-feature-card account-feature-indications"
          >
            <span class="account-feature-icon">
              <svg
                class="meter-feature-icon"
                viewBox="0 0 64 64"
                aria-hidden="true"
              >
                <rect x="14" y="8" width="36" height="46" rx="9" />
                <rect x="20" y="15" width="24" height="15" rx="3" />
                <path d="M24 22h16" />
                <circle cx="25" cy="39" r="2.4" />
                <circle cx="32" cy="39" r="2.4" />
                <circle cx="39" cy="39" r="2.4" />
                <path d="M23 47h18" />
                <path d="M24 54v4M32 54v4M40 54v4" />
              </svg>
            </span>
            <span class="account-feature-label">
              <span class="account-feature-title">
                {{ $t("buttons.putIndications") }}
              </span>
              <span class="account-feature-arrow">›</span>
            </span>
          </router-link>
        </div>

        <h2 class="account-actions-title">Інші дії</h2>

        <div class="account-actions-list">
          <router-link
            :to="{ name: 'PaymentHistorySearchResults', params: $route.params }"
            class="account-action-row"
          >
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <rect x="12" y="16" width="40" height="36" rx="8" />
                <path d="M21 10v10M43 10v10M13 27h38" />
                <path d="M22 36h6M32 36h6M42 36h4M22 44h6M32 44h6" />
              </svg>
            </span>
            <span>{{ $t("buttons.paymentHistory") }}</span>
          </router-link>

          <router-link
            :to="{ name: 'IndicationsHistory', params: $route.params }"
            class="account-action-row"
          >
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <path d="M18 10h24l8 8v36H18Z" />
                <path d="M42 10v10h8" />
                <path d="M26 30h14M26 38h14M26 46h10" />
                <path d="M19 54h28" />
              </svg>
            </span>
            <span>{{ $t("buttons.indicationsHistory") }}</span>
          </router-link>

          <router-link
            :to="{ name: 'WriteTicket', params: $route.params }"
            class="account-action-row"
          >
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <path
                  d="M20 14h24a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H30L18 53v-9h-2a8 8 0 0 1-8-8V22a8 8 0 0 1 8-8Z"
                />
                <path d="M23 27h18M23 35h12" />
              </svg>
            </span>
            <span>{{ $t("buttons.contactUs") }}</span>
          </router-link>

          <button class="account-action-row" type="button" @click="socialShare">
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <circle cx="18" cy="32" r="7" />
                <circle cx="46" cy="18" r="7" />
                <circle cx="46" cy="46" r="7" />
                <path d="m24 29 16-8M24 35l16 8" />
              </svg>
            </span>
            <span>{{ $t("buttons.socialShare") }}</span>
          </button>

          <button class="account-action-row" type="button" @click="runRate">
            <span class="account-action-icon">
              <svg viewBox="0 0 64 64" aria-hidden="true">
                <path
                  d="m32 10 6.5 13.2 14.5 2.1-10.5 10.2 2.5 14.4L32 43l-13 6.9 2.5-14.4L11 25.3l14.5-2.1Z"
                />
              </svg>
            </span>
            <span>{{ $t("buttons.rateApp") }}</span>
          </button>
        </div>
        <!--
        <div v-if="account && !hideFloatingGift" class="account-gift-fixed">
          <idea-bank-floating-gift />
        </div>
        <div v-if="account" class="account-offer-wrap">
          <idea-bank-home-banner
            ref="accountOfferBanner"
            class="account-offer-banner"
          />
        </div>
        <div v-if="account" class="account-offer-bottom-spacer"></div>
        -->
      </div>
    </van-col>
  </van-row>
</template>
<script>
import Account from "@/components/helpers/Account";
// import IdeaBankHomeBanner from "@/components/idea-bank/IdeaBankHomeBanner";
// import IdeaBankFloatingGift from "@/components/idea-bank/IdeaBankFloatingGift";
import edopomogaLogo from "@/assets/images/edopomoga-logo-Photoroom.png";
import Donora from "@/plugins/api/factories/Donora";

const DONORA_LINK =
  "https://donora.help/app?utm_source=zhytomyr_energo&utm_medium=partner&utm_campaign=ua_utilities_app_install&utm_content=energy";

export default {
  name: "Index",
  components: {
    // IdeaBankFloatingGift,
    // IdeaBankHomeBanner,
    Account,
  },
  data() {
    return {
      isLoading: false,
      hideFloatingGift: false,
      giftObserver: null,
      edopomogaLogo,
    };
  },
  computed: {
    account() {
      return this.$store.state.Auth.account;
    },
  },
  created() {
    this.getPageData();
  },
  mounted() {
    this.$nextTick(this.setupGiftObserver);
  },
  beforeDestroy() {
    this.teardownGiftObserver();
  },
  watch: {
    account(value) {
      if (value) {
        this.$nextTick(this.setupGiftObserver);
      } else {
        this.teardownGiftObserver();
      }
    },
  },
  methods: {
    async openDonoraTicker() {
      const link = DONORA_LINK;

      try {
        await Donora.link(this.getDonoraPayload(link));
      } catch (error) {
        console.error("Donora link tracking error:", error);
      } finally {
        this.openExternalUrl(link);
      }
    },
    getDonoraPayload(link) {
      return {
        account_number: this.account
          ? this.account.ls
          : this.$route.params.account,
        address: this.getAccountAddress(),
        link,
      };
    },
    getAccountAddress() {
      if (!this.account) {
        return "";
      }

      const addressParts = [
        this.account.streetType,
        this.account.streetName,
        this.account.building,
        this.account.appartment
          ? `${this.$t("components.accounts.apartment")} ${
              this.account.appartment
            }`
          : "",
        this.account.city,
      ];

      return addressParts.filter(Boolean).join(", ");
    },
    openExternalUrl(url) {
      if (typeof this.nativeSendEvent === "function") {
        this.nativeSendEvent("url", url);
        return;
      }

      window.open(url, "_blank", "noopener");
    },
    runRate() {
      window.location.href = "https://billing.city/zhytomyr.energo";
      this.nativeSendEvent("url", "https://billing.city/zhytomyr.energo");
    },
    navigateToExternalLink() {
      window.location.href = "https://onelink.to/jyeydu";
    },
    async getPageData() {
      this.isLoading = true;
      try {
        await this.checkForCorrectParameters();
        await this.$store.dispatch("Payment/getCardsList");
      } finally {
        this.isLoading = false;
      }
    },
    async checkForCorrectParameters() {
      if (Object.keys(this.$route.params).length) {
        if (this.$route.params.account !== undefined) {
          this.isLoading = true;
          try {
            await this.$store.dispatch(
              "Auth/getUserAccount",
              this.$route.params.account
            );
          } finally {
            // Оставляем isLoading = true, так как общая загрузка еще не завершена
            // isLoading будет установлен в false в методе getPageData
          }
        } else {
          console.error(
            "WARNING: somehow user opened account page without provided account parameter!"
          );
          await this.$router.push({ name: "Home" });
        }
      } else {
        console.error(
          "WARNING: somehow user opened account page any parameters!"
        );
        await this.$router.push({ name: "Home" });
      }
    },
    socialShare() {
      this.nativeSendEvent("socialShare", {
        text:
          this.$t("settings.title") +
          " " +
          "https://billing.city/zhytomyr.energo",
        subject: this.$t("settings.subject"),
      });
    },
    setupGiftObserver() {
      this.teardownGiftObserver();

      if (!this.account || !this.$refs.accountOfferBanner) {
        this.hideFloatingGift = false;
        return;
      }

      if (typeof IntersectionObserver === "undefined") {
        this.hideFloatingGift = false;
        return;
      }

      const target =
        this.$refs.accountOfferBanner.$el || this.$refs.accountOfferBanner;

      this.giftObserver = new IntersectionObserver(
        (entries) => {
          this.hideFloatingGift = entries.some((entry) => entry.isIntersecting);
        },
        {
          root: null,
          rootMargin: "0px 0px 120px 0px",
          threshold: 0,
        }
      );
      this.giftObserver.observe(target);
    },
    teardownGiftObserver() {
      if (this.giftObserver) {
        this.giftObserver.disconnect();
        this.giftObserver = null;
      }
    },
  },
};
</script>
<style scoped>
@import "../../../node_modules/vant/lib/dialog/index.css";
@import "../../../node_modules/vant/lib/overlay/index.css";
@import "../../../node_modules/vant/lib/popup/index.css";
.page-wrapper {
  padding-bottom: calc(44px + env(safe-area-inset-bottom, 0px));
}
.main-page-account {
  width: min(337px, calc(100vw - 32px));
  margin: 0 auto;
  padding: 14px 0 12px;
}

.main-page-account.place-content-center {
  overflow: visible;
}

.donora-ticker {
  position: relative;
  display: flex !important;
  align-items: center;
  width: 100vw;
  min-width: 100vw;
  height: 40px;
  margin-left: 50%;
  padding: 0;
  border: 0;
  overflow: hidden;
  transform: translateX(-50%);
  isolation: isolate;
  box-sizing: border-box;
  background: #239b5b;
  color: #ffffff;
  cursor: pointer;
  font: inherit;
  text-decoration: none;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22),
    inset 0 -1px 0 rgba(0, 0, 0, 0.14);
}

.donora-ticker-heart {
  position: absolute;
  left: max(10px, env(safe-area-inset-left, 0px));
  top: 50%;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 32px;
  transform: translateY(-50%);
  line-height: 1;
  text-shadow: none;
}

.donora-ticker-heart svg {
  width: 23px;
  height: 23px;
  display: block;
  filter: drop-shadow(0 0 5px rgba(255, 73, 111, 0.55));
}

.ticker-heart-fill {
  fill: url("#donoraTickerHeartGlow");
  stroke: none;
}

.ticker-heart-shine {
  fill: none;
  stroke: url("#donoraTickerHeartShine");
  stroke-width: 4;
  stroke-linecap: round;
}

.donora-ticker-heart::after {
  content: "";
  position: absolute;
  inset: -5px -22px -5px -12px;
  z-index: -1;
  background: linear-gradient(
    90deg,
    #239b5b 0%,
    #239b5b 78%,
    rgba(35, 155, 91, 0) 100%
  );
}

.donora-ticker-viewport {
  position: relative;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  padding-left: calc(max(10px, env(safe-area-inset-left, 0px)) + 48px);
  padding-right: max(12px, env(safe-area-inset-right, 0px));
  -webkit-mask-image: linear-gradient(
    90deg,
    transparent 0,
    #000 28px,
    #000 calc(100% - 28px),
    transparent 100%
  );
  mask-image: linear-gradient(
    90deg,
    transparent 0,
    #000 28px,
    #000 calc(100% - 28px),
    transparent 100%
  );
}

.donora-ticker-track {
  display: inline-flex;
  width: max-content;
  align-items: center;
  gap: 0;
  position: relative;
  z-index: 1;
  white-space: nowrap;
  color: #ffffff;
  font-size: 15px;
  font-weight: 800;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  animation: donora-ticker-scroll 16s linear infinite;
}

.donora-ticker-track span {
  display: inline-block;
  padding-right: 64px;
}

@keyframes donora-ticker-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.account-menu-modern,
.account-menu-modern * {
  box-sizing: border-box;
}

.account-pay-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 56px;
  margin: 0 0 20px;
  border-radius: 12px;
  background: #467cf2;
  color: #ffffff;
  font-family: inherit;
  font-size: 17.5px;
  font-weight: 650;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  box-shadow: 0 8px 16px rgba(35, 77, 164, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.16);
}

.account-pay-button:active {
  transform: translateY(1px);
}

.account-feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
}

.account-feature-card {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 146px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
  padding: 16px 18px 18px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  background: #0e121b;
  color: #ffffff;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.account-feature-card::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  background: #4285f4;
  box-shadow: 0 0 16px rgba(66, 133, 244, 0.62);
}

.account-feature-donora::after {
  background: #38c986;
}

.account-feature-card > * {
  position: relative;
  z-index: 1;
}

.account-feature-icon {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(66, 133, 244, 0.22);
  color: #ffffff;
}

.account-feature-icon svg {
  width: 31px;
  height: 31px;
  fill: none;
  stroke: currentColor;
  stroke-width: 3.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.account-feature-icon .meter-feature-icon {
  width: 34px;
  height: 34px;
  stroke-width: 3;
}

.account-feature-logo {
  border-radius: 12px;
  background: #000000;
}

.account-feature-logo img {
  width: 46px;
  height: 46px;
  display: block;
  object-fit: contain;
}

.account-feature-label {
  width: 100%;
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.account-feature-title {
  min-width: 0;
  display: block;
  color: #ffffff;
  font-family: inherit;
  font-size: clamp(16px, 4.1vw, 17.5px);
  font-weight: 760;
  line-height: 1.14;
  overflow-wrap: normal;
  word-break: normal;
}

.account-feature-arrow {
  flex: 0 0 auto;
  color: #4285f4;
  font-size: 32px;
  font-weight: 250;
  line-height: 1;
}

.account-feature-donora .account-feature-arrow {
  color: #38c986;
}

.account-actions-title {
  margin: 18px 0 12px;
  color: #ffffff;
  font-family: inherit;
  font-size: 19px;
  font-weight: 760;
  line-height: 1.1;
  text-align: left;
}

.account-actions-list {
  overflow: hidden;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  background: #0e121b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.account-action-row {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 14px;
  align-items: center;
  width: 100%;
  min-height: 64px;
  padding: 11px 18px;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: #0e121b;
  color: #ffffff;
  cursor: pointer;
  font: inherit;
  text-align: left;
  text-decoration: none;
}

.account-action-row:last-child {
  border-bottom: 0;
}

.account-action-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #1a2942;
  color: #ffffff;
}

.account-action-icon svg {
  width: 27px;
  height: 27px;
  fill: none;
  stroke: currentColor;
  stroke-width: 3.1;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.account-action-row span:last-child {
  min-width: 0;
  color: #ffffff;
  font-family: inherit;
  font-size: clamp(16px, 4.2vw, 18px);
  font-weight: 740;
  line-height: 1.18;
}
.page-type {
  padding: 15px 0 0 0;
  font-size: 18px;
  margin: 0;
  color: #0b0b0b;
  background-color: #fff;
}
.home-account-shadow {
  border-radius: 0 0 15px 15px;
  -webkit-box-shadow: 0 6px 4px 0 rgba(34, 60, 80, 0.17);
  -moz-box-shadow: 0 6px 4px 0 rgba(34, 60, 80, 0.17);
  box-shadow: 0 6px 4px 0 rgba(34, 60, 80, 0.17);
}
.top-radius {
  border-radius: 15px 15px 0 0;
}
.account-icon {
  width: 48px !important;
  height: 48px !important;
  margin: -8px;
}

.account-skeleton {
  background-color: #1e1e1e;
  border-radius: 15px;
  padding: 20px;
  margin: 15px auto;
  max-width: 337px;
  width: 100%;
}

.skeleton-line {
  height: 20px;
  background: linear-gradient(90deg, #333 25%, #444 50%, #333 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 10px;
}

.skeleton-line:nth-child(1) {
  width: 80%;
}

.skeleton-line:nth-child(2) {
  width: 90%;
}

.skeleton-line:nth-child(3) {
  width: 70%;
}

.skeleton-line:nth-child(4) {
  width: 60%;
}

.account-offer-wrap {
  clear: both;
  width: min(369px, calc(100vw - 4px));
  margin-left: 50%;
  padding: 12px 16px 14px;
  transform: translateX(-50%);
  overflow: visible;
  box-sizing: border-box;
  filter: drop-shadow(0 0 14px rgba(56, 189, 248, 0.22));
}

.account-offer-banner {
  margin-top: 0;
  margin-bottom: 0;
}

.account-offer-bottom-spacer {
  width: 100%;
  height: calc(36px + env(safe-area-inset-bottom, 0px));
  flex-shrink: 0;
}

.account-gift-fixed {
  position: fixed;
  left: 50%;
  bottom: calc(92px + env(safe-area-inset-bottom, 0px));
  z-index: 30;
  display: flex;
  justify-content: flex-end;
  width: min(337px, calc(100vw - 32px));
  pointer-events: none;
  transform: translateX(calc(-50% + 10px));
}

.account-gift-fixed > * {
  pointer-events: auto;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (max-width: 340px) {
  .nav-btn {
    width: 50%;
  }
}
</style>
